import React, { useState } from 'react'
import * as pageUtils from './__index.utils'
import { formatStrapiText } from '@utils/methods'
import { DOSSIER_FORM, PAIEMENT_TYPE } from './__index.utils'

type propsType = {
  pageData: any
  dossier: DOSSIER_FORM | undefined
}

const PaymentInfosSection: React.FC<propsType> = ({ pageData, dossier }) => {
  /* Payment details toggle
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  */

  const paiementType = dossier?.PAIEMENT?.PAIEMENT_TYPE;
  let paiements: PAIEMENT_TYPE[] = paiementType
    ? Array.isArray(paiementType)
      ? paiementType
      : [paiementType]
    : [];

  paiements = paiements.sort(
    (a, b) => new Date(b.PAYE_LE).getTime() - new Date(a.PAYE_LE).getTime()
  );

  const formatMontant = (montant: string) =>
    Number(montant).toLocaleString("fr-CA", {
      minimumFractionDigits: 2,
    }) + "$";

  const renderPayementInfoRow = () => (
    paiements.length > 0 && (
      <div className={pageUtils.classes.paymentContainer}>
        <div className={pageUtils.classes.paymentHeader}>
          <div className={pageUtils.classes.paymentColLeft}>
            <div className={pageUtils.classes.paymentHeaderCell}>
              <strong>Date du paiement</strong>
            </div>
          </div>
          <div className={pageUtils.classes.paymentColRight}>
            <div className={pageUtils.classes.paymentHeaderCell}>
              <strong>Montant payé</strong>
            </div>
          </div>
        </div>

        {paiements.map((p, idx) => {
          // Payment details toggle
          //const isOpen = openIndex === idx;
          return (
            <React.Fragment key={idx}>
              <div
                className={pageUtils.classes.paymentRow}
                // Payment details toggle
                //onClick={() => setOpenIndex(isOpen ? null : idx)}
              >
                <div className={pageUtils.classes.paymentDate}>{p.PAYE_LE}</div>
                <div className={pageUtils.classes.paymentAmount}>
                  {formatMontant(p.MONTANT)}
                </div>
              </div>

              {/* Payment details toggle
              isOpen && (
                <div className={pageUtils.classes.paymentDetails}>
                  <div className={pageUtils.classes.paymentDetailRow}>
                    <div className={pageUtils.classes.paymentDetailLabel}>
                      Numéro de référence
                    </div>
                    <div>{p.NO_RECU_FMT}</div>
                  </div>
                  <div className={pageUtils.classes.paymentDetailRow}>
                    <div className={pageUtils.classes.paymentDetailLabel}>
                      Montant payé
                    </div>
                    <div>{formatMontant(p.MONTANT)}</div>
                  </div>
                  <div className={pageUtils.classes.paymentDetailRow}>
                    <div className={pageUtils.classes.paymentDetailLabel}>
                      Date du paiement
                    </div>
                    <div>{p.PAYE_LE}</div>
                  </div>
                  <div className={pageUtils.classes.paymentDetailRow}>
                    <div className={pageUtils.classes.paymentDetailLabel}>
                      Numéro de référence de la transaction
                    </div>
                    <div>{p.NO_DEPOT}</div>
                  </div>
                </div>
              )*/}
            </React.Fragment>
          );
        })}
      </div>
    )
  );

  return (
    <>
      {dossier?.PAIEMENT?.PAIEMENT_TYPE ? (
        renderPayementInfoRow()
      ) : (
        <p className={`${pageUtils.classes.paragraph} no-payment`}>
          {formatStrapiText(
            pageData.assets?.page_requestDetails_no_payment_available
          )}
        </p>
      )}
    </>
  );
};


export default PaymentInfosSection
